
import { getRules } from '../../services/game.services';
export const FETCH_RULES_REQUEST = 'FETCH_RULES_REQUEST';
export const FETCH_RULES_SUCCESS = 'FETCH_RULES_SUCCESS';
export const FETCH_RULES_FAILURE = 'FETCH_RULES_FAILURE';

export const GET_ALL_RULES = "GET_ALL_RULES";
export const LOGOUT = "LOGOUT";

export const GetAllRulesAction = () => {
  return async (dispatch, getState) => {
    const {
      auth: { user },
    } = await getState();
    try {
      let result = await getRules(user?.token);
      dispatch({
        type: GET_ALL_RULES,
        payload: result.data,
      });
    } catch (e) {
      console.log("error at GetAllRulesAction =====>", e);
    }
  };
};
export const fetchRulesRequest = () => ({
  type: FETCH_RULES_REQUEST,
});

export const fetchRulesSuccess = (rules) => ({
  type: FETCH_RULES_SUCCESS,
  payload: rules,
});

export const fetchRulesFailure = (error) => ({
  type: FETCH_RULES_FAILURE,
  payload: error,
});

export const fetchRules = (data) => {
  return async (dispatch) => {
    dispatch(fetchRulesRequest());
    try {
      const response = await getRules(data);
      dispatch(fetchRulesSuccess(response.data));
    } catch (error) {
      dispatch(fetchRulesFailure(error.message));
    }
  };
};
